<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('public.writingandprinting.title') }}
        <Bookmark service_type_code='6418' />

        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('public.title') }} > </span>
            <span class="middle_loc">{{ $t('public.writingandprinting.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">

          <v-layout class="step_wrapper type2">
            <v-flex class="step_box step01 active">
              <h2>{{ $t('public.writingandprinting.fields.step_01') }}</h2>
              <p>{{ $t('public.writingandprinting.fields.search_application') }}</p>
            </v-flex>
            <v-flex class="step_box step02">
              <h2>{{ $t('public.writingandprinting.fields.step_02') }}</h2>
              <p>{{ $t('public.writingandprinting.fields.enter_details') }}</p>
            </v-flex>
            <v-flex class="step_box step03">
              <h2>{{ $t('public.writingandprinting.fields.step_03') }}</h2>
              <p>{{ $t('public.writingandprinting.fields.review_submit') }}</p>
            </v-flex>
          </v-layout>

          <v-layout class="inner_contents mt-30" column>

            <!-- UI 변경 해야됨... -->
            <v-flex>

              <v-row>
                <v-col cols="12" class="pt-0">
                  <h2 class="m_title">{{ $t('public.writingandprinting.fields.request_type') }}</h2>
                  <ValidationObserver ref="observer">
                    <v-form>
                      <div class="input_text_type_basic title_box_type pa-18 pt-0 pb-0">
                        <ValidationProvider v-slot="{ errors }" :name="$t('public.writingandprinting.fields.request_type')" :rules="{required: true}">
                        <v-radio-group
                          row
                          :error-messages="errors"
                          v-model="requestType"
                        >
                          <v-radio color="#a01c2a" :label="$t('public.writingandprinting.fields.enter_application_no')" value="type1"></v-radio>
                          <v-radio color="#a01c2a" :label="$t('public.writingandprinting.fields.without_application_no')" value="type2"></v-radio>
                        </v-radio-group>
                        </ValidationProvider>
                      </div>
                    </v-form>
                  </ValidationObserver>
                </v-col>
              </v-row>

            </v-flex>

            <v-flex>
              <SearchApplication
                v-show="requestType == 'type1'"
                :applicant_show_yn.sync="applicant_show_yn"
                :service_type_code="service_type_code"
                @success="fnSuccessChk"
                @change="fnChagneApp"
              />
            </v-flex>

          </v-layout>

          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-spacer></v-spacer>
              <v-btn
                color="#a01c2a"
                dark
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                :disabled="fnCheckNext()"
                @click="fnGoNext()"
              >{{ $t('common.button.next') }}</v-btn>

            </v-col>
          </v-row>

        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import SearchApplication from '@/components/layout/SearchApplication'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Bookmark from '@/components/layout/Bookmark'

export default {
  components :{
    Bookmark,
    ValidationObserver,
    ValidationProvider,
    SearchApplication
  },
  data() {
    return {
      requestType : 'type1',
      application_no : '',
      nextYn: false,
      applicant_show_yn : true,
      service_type_code : '6418'
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {
    fnChagneApp(){
      this.application_no = ''
      this.nextYn = false
    },
    fnSuccessChk(chked_item){
      this.application_no = chked_item.application.application_no

      // 다음버튼 활성화
      if(chked_item.chkResult){
        this.nextYn =  true
      }
    },

    fnCheckNext(){
      if(this.requestType == 'type1'){
        if(this.nextYn){
          return false
        }else{
          return true
        }
      }else{
        return false
      }
    },

    fnGoNext(){
      this.$refs.observer.validate().then((valid) => {
        if(valid){

          if(this.requestType == 'type2'){
            this.application_no = ''
          }

          let params = {
            application_no : this.application_no
          }

          requestApi({
            url: '/receivings/printing',
            method: 'POST',
            data : params,
            callback: (res) => {
              if (res.res_code === '200') {
                this.$router.push({path : '/public/writingandprinting/step2/' + res.data.receipt_no})
              } else {
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnGoNext()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    }
  }
}
</script>